module.exports = __webpack_public_path__ + "img/notification-icon-active.379c74ae.svg";